<template>
  <div class="loader-wrapper" v-if='showLoader'>
    <div class="loader bg-white">
      <div class="whirly-loader"> </div>
    </div>
  </div>
  <router-view v-else />
</template>

<script>
export default {
  data() {
    return {
      showLoader: false
    }
  },
  watch: {
    $route() {
      this.showLoader = true;
      setTimeout(() => {
        this.showLoader = false
      }, 2000);
    }
  }
}
</script>

<style lang="scss" scoped>
.loader-wrapper.loderhide {
  display: none;
}
</style>
